import { Button } from '@/components/ui/button';
import { FlexCol } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { Search } from 'lucide-react';
import { FC } from 'react';
import { useNavigate } from 'react-router';

export const EmptyHistory: FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('../');
  };

  return (
    <FlexCol alignItems="center" gap="4">
      <Search className="h-10 w-10 bg-neutral-100 rounded-md p-3" />
      <FlexCol gap="1" alignItems="center">
        <Text variant="header2" color="primary">
          No chats yet
        </Text>
        <Text variant="body" color="secondary">
          Start a new chat, and you'll find it here later
        </Text>
      </FlexCol>
      <Button className="w-fit" onClick={handleClick}>
        Start a new chat
      </Button>
    </FlexCol>
  );
};
